import React from 'react';
import { formatMultiplier } from './FloatingIcon';
import { MessageType, Position, CardSearchResponseResult, MessageEnvelope, OpenPopupPayload } from '../Interfaces';
import { ReactComponent as Coin } from '../images/coin.svg';
import { ReactComponent as Logo } from '../images/stashr-logo.svg';
import { ReactComponent as Close } from '../images/x-lg.svg';

interface CurrentDetailCardProps {
  bestCard?: CardSearchResponseResult;
  closeCard: () => void;
}

// two more states to manage
// 1. when bestCard is null, should the card be shown?
// 2. when unauthenticated, should show a login CTA

const CurrentDetailCard : React.FC<CurrentDetailCardProps> = ({bestCard, closeCard}) => {

  const authenticatedView = () => {
    return(
      bestCard && (
        <div className="cardBody">
          <div className="cardBodyRow">
            <div className="multiplierAndAmount">
              <p className="multiplierAmount">{formatMultiplier(bestCard.multiplier)}</p>
              <p className="multiplierDesc">{bestCard.reason}</p>
              </div>
            <div className="creditCardName">
              <p>with your {bestCard.card.name}</p>
            </div>
          </div>
          <div
            className="hideForNowAuth"
          >
            <p>Hide for now</p>
          </div>
        </div>
      )
    )
  }

  return (
    <div
      className="currentDetailCard"
    >
      <div className="cardHeader">
        <div className="cardHeaderLeft">
          <div className="goldCircleHeader">
            <Coin className="coinSvgHeader" />
          </div>
          <div className="stashr">
            <Logo className="stashrLogo" />
          </div>
        </div>
        <Close
          className="closeButton"
          onClick={closeCard}
        />
      </div>
      {authenticatedView()}
    </div>
  )
}

export { CurrentDetailCard };
